import AnnualPeriodsError from './AnnualPeriodsError';
class AnnualPeriodsInvalidPropertyId extends AnnualPeriodsError {
    propertyId;
    constructor(propertyId, options) {
        super('Crowdfunding property id is not in the correct format', options);
        this.propertyId = propertyId;
    }
}
export default AnnualPeriodsInvalidPropertyId;
